// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pKAaC8Tjv59SZrIZHHAo {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
}

.gRH_9KkjRBDMyN0InOnq {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 12px;
  width: 100%;
  box-sizing: border-box;
}

.h093w3gJnPthmvQWoqUK {
  display: flex;
  flex-direction: column;
}

.GquBrsvIPkDoxasnkl5i {
  display: flex;
  flex-direction: row;
  width: 33.3%;
}

._EcuW6dmQyNMDe282pwW {
  background: var(--grey-color-10);
  display: flex;
  flex-direction: row;
  height: 59px;
  padding: 5px 32px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.F9Jaqm6r9_7lZgDpRrKa {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.XRsPML6hRNkW6awbPIzW {
  display: flex;
  align-items: center;
}

.EBDN3K9xlQKqW6LnO6Mh {
  display: flex;
  align-items: center;
  gap: 12px;
}

.sVrxsMc2ArbEnntOZ6sj {
  width: 2px;
  background: var(--grey-gradient-start-color-10);
  flex-shrink: 0;
}

.ZMyHrCXCupWy3a6LYH9M {
  height: 18px;
  width: 1px;
  opacity: 0.2;
  background: var(--grey-color-90);
  margin: 10px;
}

.FWNM_HUhCJYWSJGqiZzM {
  color: var(--grey-color-90);
  border-radius: 24px;
  padding: 4px 8px;
}

.IpF9078j39TUoO7HkjyR {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: row;
  gap: 16px;
}

.W2lT7F_ejQOfJc1VqMcK {
  border-radius: 10px;
  padding: 2px;
  width: 60px;
  align-items: center;
  display: flex;
  justify-content: center;
  color: var(--grey-color-90);
  text-align: center;
  font-family: var(--font-stack-full-regular);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.HvN3Pblrz6K9mq6cgY5s {
  color: var(--grey-color-90);
}

.U2WC0TQZD783Ab_t6tpu {
  display: flex;
  flex-direction: row;
}

.qRiZQsRSEdmS3OK4i1wX {
  color: var(--grey-color-90);
  font-family: var(--font-stack-full-medium);
  font-style: normal;
  line-height: 24px;
  font-weight: 500;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  max-width: 100%;
  display: inline-block;
}`, "",{"version":3,"sources":["webpack://./src/components/DevelopmentOpportunitiesBar/DevelopmentOpportunitiesBar.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,UAAA;EACA,+CAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,UAAA;EACA,YAAA;EACA,gCAAA;EACA,YAAA;AACF;;AAEA;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;EACA,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.rowWrapper {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n}\n\n.itemDetails {\n  display: flex;\n  flex-direction: row;\n  width: 33.3%;\n}\n\n.itemStyle {\n  background: var(--grey-color-10);\n  display: flex;\n  flex-direction: row;\n  height: 59px;\n  padding: 5px 32px;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.itemLeft {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.itemRight {\n  display: flex;\n  align-items: center;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.itemSeparator {\n  width: 2px;\n  background: var(--grey-gradient-start-color-10);\n  flex-shrink: 0;\n}\n\n.divider {\n  height: 18px;\n  width: 1px;\n  opacity: 0.2;\n  background: var(--grey-color-90);\n  margin: 10px;\n}\n\n.headerIconStyle {\n  color: var(--grey-color-90);\n  border-radius: 24px;\n  padding: 4px 8px;\n}\n\n.rightSide {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  gap: 16px;\n}\n\n.percentage {\n  border-radius: 10px;\n  padding: 2px;\n  width: 60px;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  color: var(--grey-color-90);\n  text-align: center;\n  font-family: var(--font-stack-full-regular);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n.icon {\n  color: var(--grey-color-90);\n}\n\n.users {\n  display: flex;\n  flex-direction: row;\n}\n\n.text {\n  color: var(--grey-color-90);\n  font-family: var(--font-stack-full-medium);\n  font-style: normal;\n  line-height: 24px;\n  font-weight: 500;\n  white-space: normal;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 16px;\n  max-width: 100%;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `pKAaC8Tjv59SZrIZHHAo`,
	"rowWrapper": `gRH_9KkjRBDMyN0InOnq`,
	"content": `h093w3gJnPthmvQWoqUK`,
	"itemDetails": `GquBrsvIPkDoxasnkl5i`,
	"itemStyle": `_EcuW6dmQyNMDe282pwW`,
	"itemLeft": `F9Jaqm6r9_7lZgDpRrKa`,
	"itemRight": `XRsPML6hRNkW6awbPIzW`,
	"header": `EBDN3K9xlQKqW6LnO6Mh`,
	"itemSeparator": `sVrxsMc2ArbEnntOZ6sj`,
	"divider": `ZMyHrCXCupWy3a6LYH9M`,
	"headerIconStyle": `FWNM_HUhCJYWSJGqiZzM`,
	"rightSide": `IpF9078j39TUoO7HkjyR`,
	"percentage": `W2lT7F_ejQOfJc1VqMcK`,
	"icon": `HvN3Pblrz6K9mq6cgY5s`,
	"users": `U2WC0TQZD783Ab_t6tpu`,
	"text": `qRiZQsRSEdmS3OK4i1wX`
};
export default ___CSS_LOADER_EXPORT___;
